<div class="password-strength-container" *ngIf="password">
  <div class="progress-bar-wrapper">
    <div class="progress-bar" [style.width.%]="getProgressPercentage()"></div>
  </div>

  <div class="password-requirements">
    <div
      class="requirement"
      *ngFor="let req of requirements; let i = index"
      [class.met]="isRequirementMet(i)"
    >
      <i class="bi bi-check2-circle requirement-icon"></i>
      <span class="requirement-text">{{ req.name }}</span>
    </div>
  </div>
</div>
